//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DisableLegacyDocumentViewEndpoints: FeatureFlag = {"Id":"DisableLegacyDocumentViewEndpoints","Label":"[10.27]Disable legacy document view endpoints","Impact":"The legacy DisplayPdf/DisplayPdfByToken (public) and ReviewPdf (admin) document endpoints are kept active for backward compatibility with previously issued links, alongside their DownloadDocument/DownloadDocumentByToken/ReviewDocument replacements. Off by default so old links keep working during rollout; enable once migrated off the legacy URLs to retire them (returns Not Found).","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
